import Vue from 'vue'
import Vuex from 'vuex'
import product from './modules/product'
import device from './modules/device'
import device_group from './modules/device_group'
import profile from './modules/profile'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
	storage: window.localStorage
})

export default new Vuex.Store({
	modules: {
		product,
		device,
		device_group,
		profile
	},
	mutations: {
		RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION // this mutation **MUST** be named "RESTORE_MUTATION"
	},
	strict: false,
	plugins: [vuexLocal.plugin]
})
